<template lang="html">
	<div class="patrimonial-form">
		<form class="form-ui landscape-patrimonial-ui" novalidate>
			<div class="ctn-toggle row">
				<div class="label">
					Possédez-vous une résidence principale ?
				</div>
				<custom-toggle :value="isRealEstate" @change="toggleMainRealEstate($event)"/>
			</div>
			<div v-if="isRealEstate">
				<div class="form-elem-container row">
					<div class="ctn-input ctn-label three" :class="{error: errors.has('montant estimé')}">
						<label for="montant estimé">Montant actuel estimé</label>
						<input v-validate="'required'" type="text" name="montant estimé" v-model="realEstateValue" :key="'main'">
						<custom-select :items="currencies" :selected="'EUR'" @change="realEstateCur=$event"/>
					</div>
					<div class="error-message">{{ errors.first('montant estimé')}}</div>
				</div>
				<div class="form-elem-container row">
					<div class="ctn-input ctn-label">
						<label for="catégorie professionnelle">Type de propriété</label>
						<custom-select :items="propertyTypes" :selected="propertyType" @change="propertyType=$event"></custom-select>
					</div>
					<div class="error-message"></div>
				</div>
			</div>
			<div class="ctn-toggle row">
				<div class="label">
					Possédez-vous une résidence secondaire ?
				</div>
				<custom-toggle :value="isSecondaryRealEstate" @change="toggleSecondaryEstates($event)"/>
			</div>
			<div class="ctn-childrens" v-if="isSecondaryRealEstate">
				<div class="ctn-children" v-for="(property, key) in secondaryEstates" v-bind:key="key">
					<div class="type-children row">
						Résidence Secondaire {{ key + 1 }} <div class="link" @click="removeSecondaryEstate(key)">supprimer</div>
					</div>
					<div class="form-elem-container row">
						<div class="ctn-input ctn-label three" :class="{error: errors.has('montant estimé ' + (key + 1))}">
							<label :for="'montant estimé' + (key + 1)">Montant actuel estimé</label>
							<input v-validate="'required'" type="text" :name="'montant estimé ' + (key + 1)" v-model="property.value" :key="'secondary-' + key">
							<custom-select :items="currencies" :selected="property.cur" @change="property.cur=$event"/>
						</div>
						<div class="error-message">{{ errors.first('montant estimé ' + (key + 1))}}</div>
					</div>
					<div class="form-elem-container row">
						<div class="ctn-input ctn-label">
							<label for="catégorie professionnelle">Type de propriété</label>
							<custom-select :items="propertyTypes" :selected="property.ownership_type" @change="property.ownership_type=$event"></custom-select>
						</div>
						<div class="error-message"></div>
					</div>
				</div>
				<div class="link" @click="addSecondaryEstate">
					Ajouter une autre résidence secondaire
				</div>
			</div>
			<div class="ctn-toggle row custom-margin">
				<div class="label">
					Possédez-vous des biens locatifs ?
				</div>
				<custom-toggle :value="isRentingProperties" @change="toggleRentingProperties($event)"/>
			</div>
			<div class="ctn-childrens" v-if="isRentingProperties">
				<div class="ctn-children" v-for="(property, key) in rentingProperties" v-bind:key="key">
					<div class="type-children row">
						Bien locatif {{ '2-' + (key + 1) }} <div class="link" @click="removeRentingProperty(key)">supprimer</div>
					</div>
					<div class="form-elem-container row">
						<div class="ctn-input ctn-label three" :class="{error: errors.has('montant estimé 2-' + (key + 1))}">
							<label :for="'montant estimé 2-' + (key + 1)">Montant actuel estimé</label>
							<input v-validate="'required'" type="text" :name="'montant estimé 2-' + (key + 1)" v-model="property.value" :key="'renting-' + key">
							<custom-select :items="currencies" :selected="property.cur" @change="property.cur=$event"/>
						</div>
						<div class="error-message">{{ errors.first('montant estimé 2-' + (key + 1)) }}</div>
					</div>
					<div class="form-elem-container row">
						<div class="ctn-input ctn-label">
							<label for="catégorie professionnelle">Type de propriété</label>
							<custom-select :items="propertyTypes" :selected="property.ownership_type" @change="property.ownership_type=$event"></custom-select>
						</div>
						<div class="error-message"></div>
					</div>
				</div>
				<div class="link" @click="addRentingProperty">
					Ajouter un autre bien locatif
				</div>
			</div>
			<div class="ctn-toggle row custom-margin">
				<div class="label">
					Détenez-vous des parts de scpi ?
				</div>
				<custom-toggle :value="isSCPI" @change="toggleSCPI($event)"/>
			</div>
			<div class="ctn-childrens" v-if="isSCPI">
				<div class="ctn-cihldren">
					<div class="form-elem-container row">
						<div class="ctn-input ctn-label three" :class="{error: errors.has('montant estimé')}">
							<label for="montant estimé">Montant estimé</label>
							<input v-validate="'required'" type="text" :name="'montant estimé'" v-model="scpi.value" :key="'scpi'">
							<custom-select :items="currencies" :selected="scpi.cur" @change="scpi.cur=$event"/>
						</div>
						<div class="error-message">{{ errors.first('montant estimé')}}</div>
					</div>
					<div class="form-elem-container row">
						<div class="ctn-input ctn-label">
							<label for="catégorie professionnelle">Type de propriété</label>
							<custom-select :items="propertyTypes" :selected="scpi.type" @change="scpi.type=$event"></custom-select>
						</div>
						<div class="error-message"></div>
					</div>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
import Currency from '@/common/components/MyPatrimonialLandscape/data/Currency'
import CustomToggle from '@/common/components/Form/CustomToggle'
import CustomSelect from '@/common/components/Form/CustomSelect'
import PropertyTypes from '@/common/components/MyPatrimonialLandscape/data/PropertyTypes'
import { mapGetters } from 'vuex'

class RentalProperty {
	constructor () {
		this.value = null
		this.ownership_type = PropertyTypes[0]
		this.cur = 'EUR'
	}
}

export default {
	name: 'real-estate',
	components: {
		CustomToggle,
		CustomSelect
	},
	data () {
		return {
			currencies: Currency,
			propertyTypes: PropertyTypes,
			isRealEstate: false,
			realEstateValue: null,
			propertyType: null,
			realEstateCur: 'EUR',
			isSecondaryRealEstate: false,
			secondaryEstates: [],
			isRentingProperties: false,
			rentingProperties: [],
			isSCPI: false,
			scpi: {
				value: null,
				cur: 'EUR',
				type: null
			}
		}
	},
	mounted () {
		this.initializeRealEstate()
	},
	methods: {
		initializeRealEstate () {
			this.propertyType = this.propertyTypes[0]
			this.secondaryPropertyType = this.propertyTypes[0]
			this.scpi.type = this.propertyTypes[0]

			if (this.estate.mainEstate.val) {
				this.isRealEstate = true
				this.realEstateValue = this.estate.mainEstate.val
				this.realEstateCur = this.estate.mainEstate.cur
				this.propertyType = this.estate.mainEstate.type
			}

			if (this.estate.rentalProperties.length > 0) {
				this.isRentingProperties = true
				this.rentingProperties = this.$iRobot.arrayClone(this.estate.rentalProperties)
			}
			if (this.estate.secondaryEstates.length > 0) {
				this.isSecondaryRealEstate = true
				this.secondaryEstates = this.$iRobot.arrayClone(this.estate.secondaryEstates)
			}

			if (this.estate.isSCPI) {
				this.isSCPI = true
				this.scpi.value = this.estate.scpi.value
				this.scpi.cur = this.estate.scpi.cur
				this.scpi.type = this.estate.scpi.type
			}
		},
		toggleMainRealEstate (value) {
			if (!value) {
				this.realEstateValue = null
				this.realEstateCur = 'EUR'
				this.propertyType = this.propertyTypes[0]
			}
			this.isRealEstate = value
		},
		addRentingProperty () {
			this.rentingProperties = this.rentingProperties.concat([new RentalProperty()])
		},
		toggleRentingProperties (value) {
			this.isRentingProperties = value
			if (value && this.rentingProperties.length === 0) { this.rentingProperties = [new RentalProperty()] }
			if (!value) { this.rentingProperties = [] }
		},
		removeRentingProperty (key) {
			this.rentingProperties.splice(key, 1)
		},
		addSecondaryEstate () {
			this.secondaryEstates = this.secondaryEstates.concat([new RentalProperty()])
		},
		toggleSecondaryEstates (value) {
			this.isSecondaryRealEstate = value
			if (value && this.secondaryEstates.length === 0) { this.secondaryEstates = [new RentalProperty()] }
			if (!value) { this.secondaryEstates = [] }
		},
		removeSecondaryEstate (key) {
			this.secondaryEstates.splice(key, 1)
		},
		toggleSCPI (value) {
			this.isSCPI = value
		},
		validate () {
			return this.$validator.validate()
		},
		refreshDataSaved () {
			setTimeout(() => {
				this.initializeRealEstate()
			}, 10000)
		},
		save () {
			return new Promise((resolve, reject) => {
				this.validate().then((validation) => {
					if (validation) {
						this.$store.dispatch('storePatrimonial', {
							name: 'REAL_ESTATE',
							data: {
								mainEstate: {
									val: this.realEstateValue,
									cur: this.realEstateCur,
									type: this.propertyType
								},
								secondaryEstates: this.secondaryEstates,
								rentalProperties: this.rentingProperties,
								isSCPI: this.isSCPI,
								scpi: this.scpi
							},
							fromStart: false
						}).then(() => {
							resolve()
							this.refreshDataSaved()
						})
					}
				})
			})
		}
	},
	beforeDestroy () {
		this.save()
	},
	computed: {
		...mapGetters({
			estate: 'estate'
		})
	}
}
</script>

<style lang="scss" scoped>
	.custom-margin {
		margin-top: 0.5rem;
	}
</style>



// WEBPACK FOOTER //
// src/common/components/MyPatrimonialLandscape/RealEstate.vue